import { useState } from "react"
import { format } from "date-fns"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { shortName } from "~/lib/calendar"

// A quick note for one day at one property, added straight from the calendar.
// Cleaners see it in their portal on that day.
export default function DayNoteDialog({ day, properties, onSave, onClose }) {
  const [ propertyId, setPropertyId ] = useState(String(properties[0]?.id || ""))
  const [ body, setBody ] = useState("")
  const [ busy, setBusy ] = useState(false)
  const [ error, setError ] = useState(null)

  async function submit(event) {
    event.preventDefault()
    if (!body.trim()) return
    setBusy(true)
    setError(null)
    try {
      await onSave({ propertyId, onDate: format(day, "yyyy-MM-dd"), body: body.trim() })
    } catch (err) {
      setError(err.message)
      setBusy(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="w-full max-w-sm rounded-xl border border-border bg-card p-4 shadow-lg">
        <h2 className="font-semibold text-foreground">Note for {format(day, "EEEE d MMMM")}</h2>
        <p className="mb-3 text-xs text-muted-foreground">Shows on the calendar and in the cleaner's portal for that day.</p>
        {error && <p className="mb-2 text-sm text-destructive">{error}</p>}
        <Label>Property</Label>
        <Select value={propertyId} onValueChange={setPropertyId}>
          <SelectTrigger className="mt-1 w-full"><SelectValue /></SelectTrigger>
          <SelectContent>
            {properties.map((p) => <SelectItem key={p.id} value={String(p.id)}>{shortName(p)}</SelectItem>)}
          </SelectContent>
        </Select>
        <Label htmlFor="note-body" className="mt-3 block">Note</Label>
        <Textarea id="note-body" autoFocus rows={2} value={body} onChange={(e) => setBody(e.target.value)} placeholder="e.g. Power outage 9am–2pm, or gardener coming at 10" className="mt-1" />
        <div className="mt-3 flex justify-end gap-2">
          <Button type="button" variant="ghost" size="sm" onClick={onClose}>Cancel</Button>
          <Button type="submit" size="sm" disabled={busy || !body.trim()}>Add note</Button>
        </div>
      </form>
    </div>
  )
}
